import { Box, FlexBox } from '@dixa/lib-shared-habla';

import { ArticleSuggestion } from '../../../../types';
import { ArticleRowProps } from '../../../ArticleRow/ArticleRow';
import styles from '../../../SuggestionList/SuggestionList.module.scss';

import { ArticleSelectOption } from './ArticleSelectOption';

type ArticleSelectOptionsProps = {
  suggestions: ArticleSuggestion[];
} & Omit<ArticleRowProps, 'article' | 'isSelected'>;
export function ArticleSelectOptions({
  suggestions,
  selectedArticleId,
  onSelectArticle,
}: ArticleSelectOptionsProps): JSX.Element {
  return (
    <FlexBox className={styles.ul} as="ul" gap="300" flexDirection="column">
      {suggestions.map((suggestion) => (
        <Box as="li" key={suggestion.id}>
          <ArticleSelectOption
            article={suggestion}
            selectedArticleId={selectedArticleId}
            onSelectArticle={onSelectArticle}
          />
        </Box>
      ))}
    </FlexBox>
  );
}
